import React from "react";
import { Link } from "react-router-dom";
import "./AdminNavbar.css";

const AdminNavbar = () => {
    return (
        <div className="admin-nav">

            <Link to="/admin" className="admin-link">
                Dashboard
            </Link>

            <Link to="/admin-orders" className="admin-link">
                Orders
            </Link>

            <Link to="/admin-products" className="admin-link">
                Products
            </Link>

            <Link to="/admin-users" className="admin-link">
                Users
            </Link>

            <Link to="/" className="admin-link">
                Store
            </Link>

        </div>
    );
};

export default AdminNavbar;